module.exports = __webpack_public_path__ + "static/media/logo.59aaa533.png";